class HorizontalSlider extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.horizontal-slider-wrapper');
    this.slides = this.querySelectorAll('.slide');
    this.currentIndex = 0;
    this.xDown = null;
    this.xDiff = null;
    this.dragStartX = 0;
    this.dragging = false;
  }

  connectedCallback() {
    this.createPaginationDots();
    this.updateActiveDot();
    this.addScrollListener();
    this.addTouchSwipe();
  }

  createPaginationDots() {
    const dotsContainer = document.getElementById(`slider-dots-${this.id}`);
    if (!dotsContainer || this.slides.length <= 1) return;

    this.dots = Array.from({ length: this.slides.length }, (_, index) => {
      const button = document.createElement('button');
      button.setAttribute('aria-label', `Slide ${index + 1}`);
      button.addEventListener('click', () => this.scrollToSlide(index));
      dotsContainer.appendChild(button);
      return button;
    });
  }

  scrollToSlide(index) {
    const slideWidth = this.wrapper.offsetWidth;
    this.wrapper.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
    this.currentIndex = index;
    this.updateActiveDot();
  }

  updateActiveDot() {
    if (!this.dots) return;
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }

  addScrollListener() {
    this.wrapper.addEventListener('scroll', () => {
      const slideWidth = this.wrapper.offsetWidth;
      const index = Math.round(this.wrapper.scrollLeft / slideWidth);
      if (index !== this.currentIndex) {
        this.currentIndex = index;
        this.updateActiveDot();
      }
    });
  }

  addTouchSwipe() {
    this.wrapper.addEventListener('touchstart', (e) => {
      this.xDown = e.touches[0].clientX;
    });

    this.wrapper.addEventListener('touchmove', (e) => {
      if (!this.xDown) return;
      const xUp = e.touches[0].clientX;
      this.xDiff = this.xDown - xUp;

      if (Math.abs(this.xDiff) > 50) {
        if (this.xDiff > 0 && this.currentIndex < this.slides.length - 1) {
          this.scrollToSlide(this.currentIndex + 1);
        } else if (this.xDiff < 0 && this.currentIndex > 0) {
          this.scrollToSlide(this.currentIndex - 1);
        }
        this.xDown = null;
      }
    });

    // Optional: Mouse drag for desktop
    this.wrapper.addEventListener('mousedown', (e) => {
      this.dragStartX = e.clientX;
      this.dragging = true;
    });

    this.wrapper.addEventListener('mouseup', (e) => {
      if (!this.dragging) return;
      const dragEndX = e.clientX;
      const dragDistance = this.dragStartX - dragEndX;

      if (dragDistance > 50 && this.currentIndex < this.slides.length - 1) {
        this.scrollToSlide(this.currentIndex + 1);
      } else if (dragDistance < -50 && this.currentIndex > 0) {
        this.scrollToSlide(this.currentIndex - 1);
      }

      this.dragging = false;
    });

    this.wrapper.addEventListener('mouseleave', () => {
      this.dragging = false;
    });
  }
}

customElements.define('horizontal-slider', HorizontalSlider);
